import Prismic from "@prismicio/client";
import { createItem } from "../components/CreateUnit/items";
import * as types from "./types";
import axios from "axios";
import { itemsPopUp } from "../components/CreateUnitYishai/items";
const apiEndpoint = "https://buildtuluunit.cdn.prismic.io/api/v2";
const accessToken = process.env.REACT_APP_PRISMIC_ACCESS_TOKEN;

const Client = Prismic.client(apiEndpoint, { accessToken });

export const getPrismicItems = () => {
  return async (dispatch, getState) => {
    let itemsRes;
    let templatesObj = {};
    const itemObj = {};

    const templatesArray = ["residential", "student_housing", "custom_types"];
    const templates = {};

    await getItemsAndSerialize(itemsRes, itemObj);
    let templatesQuery = await Client.query(
      Prismic.Predicates.any("document.type", templatesArray)
    );

    templatesQuery.results.forEach((templateType) => {
      templates[templateType.type + "|" + templateType.data.location] =
        templateType.data;
    });

    Object.keys(templates).forEach((typeAndLocation) => {
      const template = templates[typeAndLocation];
      const templatesKeys = {};

      Object.keys(template)
        .filter((key) => {
          const isTemplateCategory = key.length === 1;
          return isTemplateCategory;
        })
        .forEach((key) => {
          templatesKeys[key] = template[key];
        });

      templatesObj[typeAndLocation] = {};

      Object.keys(template)
        .filter((key) => {
          const isRideItem = key.split("_")[1] === "ride";
          const isTemplateItem = key.length === 2;
          return isTemplateItem || isRideItem;
        })
        .forEach((key, index) => {
          const isRideItem = key.split("_")[1] === "ride";
          const isTemplateItem = key.length === 2;

          if (isRideItem) {
            // if (template.location === "us") {
            //   debugger;
            // }
            const newKey = templatesKeys[key.split("_")[0]];
            if (!newKey) {
              return;
            }

            if (!templatesObj[typeAndLocation]["ride"]) {
              templatesObj[typeAndLocation]["ride"] = [];
            }
            if (!templatesObj[typeAndLocation]["ride"][newKey]) {
              templatesObj[typeAndLocation]["ride"][newKey] = [];
            }

            templatesObj[typeAndLocation]["ride"][newKey] = template[key].map(
              (e) => {
                return Object.values(itemObj).find(
                  (element) => element.key === e.item1.slug
                );
              }
            );
          }

          if (isTemplateItem) {
            const newKey = templatesKeys[key.slice(-1)];

            const columnNum = key.slice(0, 1);

            if (!templatesObj[typeAndLocation][newKey]) {
              templatesObj[typeAndLocation][newKey] = [];
            }
            templatesObj[typeAndLocation][newKey].push(
              template[key].map((e) =>
                Object.values(itemObj).find(
                  (element) => element.key === e.item1.slug
                )
              )
            );
            if (columnNum === "1") {
              templatesObj[typeAndLocation][newKey][0].unshift(
                itemsPopUp.monitor
              );
            }
          }
        });
    });
    dispatch(setTemplates(templatesObj));
    dispatch(setItems(itemObj));
  };
};

export const setItems = (items) => {
  // console.log(items)

  return {
    type: types.SET_ITEMS,
    items,
  };
};

export const setTemplates = (items) => {
  // console.log(items)

  return {
    type: types.SET_TEMPLATES,
    items,
  };
};

export const getOrder = async ({ num, mail }) => {
  try {
    num = Number(num);
  } catch (e) {
    console.log({ error: e.message });
    return { error: e.message };
  }
  if (isNaN(num)) {
    console.log({ error: "Order number not valid" });
    return { error: "Order number not valid" };
  }

  let requestOptions = {
    method: "POST",
    headers: {},
    mode: "cors",
    cache: "no-cache",
    body: JSON.stringify({ orderNumber: num, email: mail }),
  };

  return await fetch(
    "https://www.tulouapp.com/_functions/getuserUnitDetails",
    requestOptions
  )
    .then((response) => {
      if (!response.ok) {
        if (response.statusText === "Not Found") {
          console.error(
            "Error in component MyTable, error msg : file: './assets/data/test-table.json' ",
            response.statusText
          );
        }
        throw new Error(response.statusText);
      }
      return response.json();
    })
    .catch((error) => {
      console.error({ error: error });
      return { error };
    })
    .catch((error) => {
      console.error("Error in MyTable in parsing json data: ", error);
      return { error };
    });
};
async function getItemsAndSerialize(itemsRes, itemObj) {
  let itemsQuery = await Client.query(
    Prismic.Predicates.any("document.type", ["item"])
  );

  itemsRes = [...itemsQuery.results.map((e) => e.data)];

  while (itemsQuery.next_page) {
    itemsQuery = await axios.get(itemsQuery.next_page);
    itemsQuery = itemsQuery.data;

    itemsRes = [
      ...itemsRes,
      ...itemsQuery.results.filter((e) => e.type === "item").map((e) => e.data),
    ];
  }

  itemsRes.forEach((i) => {
    const key = i.key?.[0]?.text || i.id;
    itemObj[key] = createItem(i, key);
  });
}
